import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Featurelist from "./FeatureProductlist/Featurelist";

export default function Features({ data = [] }) {
	console.log("Features component data:", data);

	useEffect(() => {
		AOS.init({
			duration: 500,
			easing: "ease-in-out",
			once: true,
		});
	}, []);

	return (
		<div className="overflow-x-hidden" id="collection">
			<div className="text-center mb-10 overflow-hidden" data-aos="fade-left">
				<h1 className="text-5xl font-semibold font-lora">
					Redefine Your Everyday Look
				</h1>
			</div>

			{data.length > 0 ? (
				<ul
					data-aos="fade-right"
					data-aos-duration="300"
					className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 mt-20 mb-16 px-4 lg:ps-16 lg:pe-16 md:ps-10 md:pe-10 overflow-x-hidden">
					{data.slice(0, 12).map((item, index) => (
						<Featurelist key={item._id || item.id || index} data={item} />
					))}
				</ul>
			) : (
				<div className="text-center py-10">
					<p className="text-gray-500">No featured products available</p>
				</div>
			)}
		</div>
	);
}
